import { Service, Inject } from 'typedi';
import BaseHttp from './http/EnterpriseApiHttp';
import { Transformers } from '@enterprise/common';
import { AnalyticsAccessEntity } from '../core/entity/AnalyticsAccessEntity';

@Service()
export class AnalyticsAccessService {
    constructor(@Inject('http') private readonly http: BaseHttp) {}

    /** Full catalog (all `analytics_access` definitions). */
    async getAll(): Promise<AnalyticsAccessEntity[]> {
        const data = await this.http.get(`/v2/analytics/access`);
        return this.toEntities(data);
    }

    /** Rows linked to an organization. */
    async getOrganizationAccess(organizationId: string): Promise<AnalyticsAccessEntity[]> {
        const data = await this.http.get(`/v2/analytics/access/organization/:organizationId`, { pathParams: { organizationId } });
        return this.toEntities(data);
    }

    /** Replaces all analytics access links for the organization. */
    async setOrganizationAccess(organizationId: string, analyticsAccessIds: number[]): Promise<AnalyticsAccessEntity[]> {
        const data = await this.http.put(
            `/v2/analytics/access/organization/:organizationId`,
            { analyticsAccessIds },
            { pathParams: { organizationId } },
        );
        return this.toEntities(data);
    }

    async getUserAccess(userId: string): Promise<AnalyticsAccessEntity[]> {
        const data = await this.http.get(`/v2/analytics/access/user/:userId`, { pathParams: { userId } });
        return this.toEntities(data);
    }

    async setUserAccess(userId: string, analyticsAccessIds: number[]): Promise<AnalyticsAccessEntity[]> {
        const data = await this.http.put(`/v2/analytics/access/user/:userId`, { analyticsAccessIds }, { pathParams: { userId } });
        return this.toEntities(data);
    }

    private toEntities(data: any): AnalyticsAccessEntity[] {
        return new Transformers.CollectionTransformer(new Transformers.ToTypeTransformer(AnalyticsAccessEntity)).transform(data);
    }
}
